export function notificationBadgeCount(user?: {
  unread_notifications_count?: number;
  pending_share_access_requests?: number;
} | null): number {
  const unread = user?.unread_notifications_count ?? 0;
  const pending = user?.pending_share_access_requests ?? 0;
  return unread > 0 ? unread : pending;
}
